import { Typography } from '@material-ui/core';
import React from 'react';
import {
  ContentAnalyticsCompare,
  ContentAnalyticsDrops,
  ContentAnalyticsExport,
  ContentAnalyticsGrowth,
  ContentAnalyticsImpressions,
  ContentAnalyticsRevisions,
  FeatureGrid
} from '../../components/FeatureGrid';
import { Headline } from '../../components/Headline';
import PageHead from '../../components/PageHead';
import {
  HeatmapSection,
  RevenueAttributionSection,
  RevisionsSection,
  SegmentationSection
} from '../../components/Section';
import { SEO } from '../../components/SEO';
import { SignupButtonWithChoice } from '../../components/SignupButton';
import MainLayout from '../../layouts/main';

export default () => {
  return (
    <MainLayout>
      <div>
        <SEO
          pathname="/product/optimize/"
          title="Affilimate Optimize: Content Optimization for Editorial Teams"
          description="The content optimization solution for editorial teams: on-page analytics and heatmaps, offsite and email tracking, custom dimensions, paid marketing integrations, and syndication support."
        />
        <PageHead>
          <Headline
            variant="h3"
            gutterBottom
            component="h2"
            style={{
              maxWidth: '730px',
              margin: '0 auto 36px',
              fontWeight: 900
            }}
          >
            Optimize for Publishers
          </Headline>
          <Headline
            variant="h1"
            gutterBottom
            component="h1"
            style={{
              maxWidth: '800px',
              margin: '0 auto 36px',
              fontWeight: 900
            }}
          >
            Optimize your affiliate links, content, and channels with insights
            tailored for premium content publishers.
          </Headline>
          <Typography
            variant="body1"
            color="textSecondary"
            style={{ maxWidth: '560px', margin: '24px auto 12px' }}
          >
            The content optimization solution with a strong editorial focus:
            on-page analytics and heatmaps, offsite and email tracking, custom
            dimensions, paid marketing integrations like Google Ads and
            Facebook Ads, and syndication support, plus agent analytics on
            the commerce content you already publish.
          </Typography>
          <div style={{ textAlign: 'center', margin: '48px auto 0' }}>
            <SignupButtonWithChoice text="Get started today" />
          </div>
        </PageHead>
        <HeatmapSection orientation="right" />
        <RevenueAttributionSection orientation="right" />
        <SegmentationSection orientation="right" />
        <RevisionsSection orientation="right" />
        <div style={{ maxWidth: '900px', margin: '96px auto 48px' }}>
          <Typography
            variant="h4"
            gutterBottom
            component="h2"
            style={{
              textAlign: 'center',
              fontWeight: 900
            }}
          >
            But wait, there's more
          </Typography>
          <Typography
            variant="body1"
            component="p"
            style={{
              maxWidth: '510px',
              margin: '0 auto',
              textAlign: 'center'
            }}
          >
            Here are a few more ways you can put the insights from your content
            to use
          </Typography>
        </div>
        <FeatureGrid>
          <ContentAnalyticsImpressions />
          <ContentAnalyticsGrowth />
          <ContentAnalyticsExport />
          <ContentAnalyticsDrops />
          <ContentAnalyticsRevisions />
          <ContentAnalyticsCompare />
        </FeatureGrid>
      </div>
    </MainLayout>
  );
};
